import React, { Component } from 'react'
import BookingInput from '../Booking/bookinginput';
import formhoc from './formhoc';
import { contact_api } from '../../actions/http';
import ButtonLoader from '../btnloader';

class BecomeRider extends Component {
    render() {
        const {ipState, onChange, formFilled} = this.props;
        const { name, name_err, location, bike, mileage, phone_number, phone_number_err, form_fetching } = ipState;
        return (
            <div>
                <h3 className="f-600 m-b-20 m-t-20">Become a Rider</h3>
                <div className="row">
                    <BookingInput 
                        size={12} 
                        type="text"
                        name="name"
                        onChange={onChange}
                        placeholder="Name" 
                        value={name}
                        err={name_err}
                    />
                    <BookingInput 
                        size={12} 
                        type="number"
                        name="phone_number"
                        placeholder="Phone Number" 
                        maxLength={10}
                        onChange={onChange}
                        value={phone_number}
                        err={phone_number_err}
                    />
                    <div className="col-md-6">
                        <select onChange={onChange} value={bike} name="bike" className="form-control input-md">
                            <option value="Bike">Bike</option>
                        </select>
                    </div>
                    <div className="col-md-6">
                        <select onChange={onChange} value={mileage} name="mileage" className="form-control input-md">
                            <option value="40 kmpl">40 kmpl</option>
                            <option value="45 kmpl">45 kmpl</option>
                            <option value="50 kmpl">50 kmpl</option>
                            <option value="55 kmpl">55 kmpl</option>
                        </select>
                    </div>
                    <div className="col-md-12">
                        <select value={location} onChange={onChange} name="location" className="form-control input-md">
                            <option value="Chennai">Chennai</option>
                            <option value="Mumbai">Mumbai</option>
                            <option value="Kolkata">Kolkata</option>
                            <option value="Bengaluru">Bengaluru</option>
                        </select>
                    </div>
                    <div className="col-md-12">
                        <button disabled={formFilled && !form_fetching ? false : true} type="submit" className="btn m-t-10 btn-block btn-ouja">{ form_fetching ? <ButtonLoader /> : 'Submit' }</button>
                    </div>
                </div>
            </div>
        )
    }
}

const inputs = [
    {
        name: "name"
    },
    {
        name: "phone_number",
        validate: {type: "PHONE_NUMBER"}
    },
    {
        name: "bike",
        defaultValue: "Bike"
    },
    {
        name: "mileage",
        defaultValue: "40 kmpl"
    },
    {
        name: "location",
        defaultValue: "Chennai"
    },
    {
        name: "type",
        defaultValue: 2
    }
];

const formConfig = {
    url: contact_api,
    method: "POST" 
};

export default formhoc(BecomeRider, inputs, formConfig);
